import { render } from "./LoginRecoverSuccess.vue?vue&type=template&id=b1ab3702&scoped=true"
import script from "./LoginRecoverSuccess.vue?vue&type=script&lang=js"
export * from "./LoginRecoverSuccess.vue?vue&type=script&lang=js"

import "./LoginRecoverSuccess.vue?vue&type=style&index=0&id=b1ab3702&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ab3702"]])

export default __exports__